module.exports = __webpack_public_path__ + "img/流程-4.2ebbe7a2.jpg";